var $754ea877f466b46b$exports = {};
$754ea877f466b46b$exports = {
    "longPressMessage": `Ponuku otvor\xedte dlh\xfdm stla\u{10D}en\xedm alebo stla\u{10D}en\xedm kl\xe1vesu Alt + kl\xe1vesu so \u{161}\xedpkou nadol`
};


export {$754ea877f466b46b$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
